import { createContext } from "react";

/**
 * Contexts used across the app.
 *
 * - ProfileData: User data only (from localStorage "user_session"). One per user.
 * - ApplicationData: Current application status/data (in memory only). A user can have
 *   multiple applications; this holds the one for the current route. Driven by
 *   applicationId in the URL (e.g. /los/:applicationId/apply). When applicationId
 *   changes, Dashboard fetches and updates this context so children always see the
 *   correct application's details.
 */
export const custom_context = {
  ModalContext: createContext(false),
  ProfileData: createContext(null),
  ApplicationData: createContext(null),
};
